import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as homePageStore from "../../../redux/store/home-page/home-page.store";
import * as appActions from "../../../core/app.store";

import "./slider.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { APIUrlDefault } from "../../../utils/configuration";
import UrlCollect from "../../../common/url-collect";
import { useHistory } from "react-router-dom";

function HomeSliderView(props) {
  const { showLoading } = props;
  let history = useHistory();

  const settingSlider = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const [slideShow, setSlideShow] = useState([]);

  const [sliderHeight, setSliderHeight] = useState('auto');
  function calIframeHeight() {
    var headerHeight = document.getElementById('header-map-page-container').offsetHeight;
    var windowHeight = window.innerHeight;

    setSliderHeight((windowHeight - headerHeight) + 'px');
}

  useEffect(() => {
    onGetData();
    calIframeHeight();

    window.addEventListener("resize", calIframeHeight);

    return () => {
      window.removeEventListener("resize", calIframeHeight);
    };

  }, []);

  const onGetData = () => {
    showLoading(true);
    Promise.all([
      onGetSlideShow(),
    ])
      .then((res) => {
        showLoading(false);
      })
      .catch((err) => {
        showLoading(false);
      });
  };

  const onGetSlideShow = () => {
    return new Promise((resolve, reject) => {
      props
        .getSlideShow()
        .then((res) => {
          setSlideShow(res && res.content && res.content.length > 0 ? res.content : []);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  };

  return (
      <div>
        {slideShow && slideShow.length > 0 && (
          <div id="slider-home-page" className="slider-home-page" style={{height: sliderHeight}}>
            <Slider {...settingSlider} >
              {slideShow.map(
                (item, index) =>
                  typeof item == 'string' ? <>
                    <div className="banner" key={index}>
                      {/* <a target="_blank" href={item && item.link ? item.link : ""}>
                        <img src={require(`../../assets/image/Banner-THANH-THUY.jpg`)} alt="Map" />
                      </a> */}
                    </div>
                  </> : <>
                    {
                      item.status && (
                          <div className="banner" key={index} style={{
                            height: sliderHeight
                          }}>
                            <a href={item && item.link ? item.link : ""} target="_blank" rel="noopener noreferrer">
                              <img src={APIUrlDefault + item.avatar} alt="Map" />
                            </a>
                          </div>
                        )
                    }
                    <img
                      id="play_intro_btn"
                      src="./play_intro.png"
                      alt=""
                      onClick={() => {
                        history.push(UrlCollect.VR_map);
                      }}
                    />
                  </>
              )}
              {/* <img
                id="play_intro_btn"
                src="./play_intro.png"
                alt=""
                onClick={() => {
                  history.push(UrlCollect.VR_map);
                }}
              /> */}
            </Slider>
          </div>
        )}
      </div>
  );
}

const mapStateToProps = (state) => ({
  isLoading: state.app.loading,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showLoading: appActions.ShowLoading,
      getSlideShow: homePageStore.GetSlideShow,
    },
    dispatch
  );

export default  (connect(mapStateToProps, mapDispatchToProps)(HomeSliderView));
